"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgMap(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "3 -4 18 24" }, props),
        React.createElement("path", { d: "M14.683.053a1 1 0 01.634 0l5 1.67a1 1 0 01.683.949v12.156a1 1 0 01-1.347.938l-4.323-1.598a1 1 0 00-.664-.01l-5.349 1.79a1 1 0 01-.634 0l-5-1.673A1 1 0 013 13.326V1.336a1 1 0 011.317-.95l4.366 1.46a1 1 0 00.634 0zM9 4.026a1 1 0 00-1 1v7a1 1 0 102 0v-7a1 1 0 00-1-1zm6-1.02a1 1 0 00-1 1v7a1 1 0 102 0v-7a1 1 0 00-1-1z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Map')(SvgMap);
//# sourceMappingURL=Map.js.map